import {
  CardDisputeAccountStatus,
  type CardDisputeMerchandiseOrServices,
  CardDisputeMerchantContactMethod,
} from '@column/api';

import { type FraudType, type MerchantReturnRefusalReason } from './questionnaire';

export const FRAUD_TYPE_LABELS: Record<FraudType, string> = {
  lost: 'Card lost',
  stolen: 'Card stolen',
  card_not_received_as_issued: 'Card not received as issued',
  fraudulent_application: 'Fraudulent application',
  counterfeit: 'Counterfeit card',
  miscellaneous_account_takeover: 'Miscellaneous account takeover',
  card_absent: 'Card-absent transaction',
  acquirer_reported: 'Fraud reported by the acquirer',
  incorrect_processing: 'Incorrect processing',
  account_or_credentials_takeover: 'Account or credentials takeover',
  merchant_misrepresentation: 'Merchant misrepresentation',
  manipulation_of_account_holder: 'Manipulation of the account holder',
};

export const ACCOUNT_STATUS_LABELS: Record<CardDisputeAccountStatus, string> = {
  [CardDisputeAccountStatus.ACCOUNT_CLOSED]: 'Account was closed',
  [CardDisputeAccountStatus.CREDIT_PROBLEM]: 'Account had a credit problem',
  [CardDisputeAccountStatus.FRAUD]: 'Account was flagged for fraud',
};

export const MERCHANDISE_OR_SERVICES_LABELS: Record<CardDisputeMerchandiseOrServices, string> = {
  merchandise: 'Merchandise',
  services: 'Services',
};

export const MERCHANT_CONTACT_METHOD_LABELS: Record<CardDisputeMerchantContactMethod, string> = {
  [CardDisputeMerchantContactMethod.EMAIL]: 'Email',
  [CardDisputeMerchantContactMethod.CALL_CENTER]: 'Call center',
  [CardDisputeMerchantContactMethod.MAIL]: 'Mail',
  [CardDisputeMerchantContactMethod.SMS]: 'SMS',
  [CardDisputeMerchantContactMethod.IN_PERSON]: 'In person',
  [CardDisputeMerchantContactMethod.WEBFORM]: 'Webform or app',
};

export const MERCHANT_RETURN_REFUSAL_REASON_LABELS: Record<MerchantReturnRefusalReason, string> = {
  refused_return_authorization: 'Merchant refused a return authorization',
  refused_accept_returned_merchandise: 'Merchant refused to accept the returned merchandise',
  advised_not_to_return: 'Merchant advised the cardholder not to return the merchandise',
  no_longer_exists_or_not_responding: 'Merchant no longer exists or is not responding',
  did_not_provide_clear_return_instructions: 'Merchant did not provide clear return instructions',
};
